module.exports = __webpack_public_path__ + "static/img/アセット 24@2x.2c38d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 24@2x.png
// module id = GgVE
// module chunks = 1